import {createBrowserHistory} from "@tanstack/react-location";

export const navigateBack = () => {
  const history = createBrowserHistory();
  history.back();
};
